import React from "react";

import { faPause } from "@fortawesome/sharp-solid-svg-icons/faPause";
import { faPlay } from "@fortawesome/sharp-solid-svg-icons/faPlay";

import { Button } from "~components/Button";
import { IconFontAwesome } from "~components/IconFontAwesome";

import * as styles from "./styles.css";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

export interface VideoPlayButtonProps {
  onClick?(...args: Array<unknown>): unknown;

  isPlaying?: boolean;
}

export function VideoA11yPlayButton({
  isPlaying,
  onClick,
}: VideoPlayButtonProps) {
  return (
    <Button
      onClick={onClick}
      aria-label="play"
      className={styles.playButtonStyle}
    >
      <IconFontAwesome
        icon={isPlaying ? (faPause as IconProp) : (faPlay as IconProp)}
      />
    </Button>
  );
}
